import { gql } from 'apollo-angular';

export class VehiclesQueries {
    public static getAllVehicles = gql`
        query VehiclesFromTestItApi {
            bookingGetVehicleDetailsFromTestIt {
                VinNumber
                Name
                VehicleOwnerName
                TypeDesignation
            }
        }
    `;
}